// Jazykové URL prefixy: čeština primární bez prefixu (/), ostatní s prefixem (/en, /de…).
// Router basename se nastaví podle prefixu → všechny <Link>/navigate se prefixují automaticky.
import { relocalizePath } from './localizedUrl'

export const PREFIX_LANGS = ['en', 'de', 'pl', 'sk', 'it', 'hu', 'uk', 'es', 'fr', 'nl', 'ja'] as const

const isPrefix = (seg: string): boolean => (PREFIX_LANGS as readonly string[]).includes(seg)

/** Vrátí jazyk z prefixu URL (/en/... → 'en'), nebo null pro češtinu (bez prefixu). */
export function getPathLang(): string | null {
  const seg = (typeof window !== 'undefined' ? window.location.pathname : '/').split('/')[1] || ''
  return isPrefix(seg) ? seg : null
}

/** basename pro BrowserRouter: '/en' pro prefixovaný jazyk, jinak '/'. */
export function langBasename(): string {
  const l = getPathLang()
  return l ? '/' + l : '/'
}

/** Sestaví cílovou URL pro přepnutí na daný jazyk — přelokalizuje segment i slug. */
export function buildLangUrl(code: string): string {
  const parts = window.location.pathname.split('/')
  const fromLang = isPrefix(parts[1]) ? parts[1] : 'cs'
  if (isPrefix(parts[1])) parts.splice(1, 1) // odstraň stávající prefix
  let rest = parts.join('/')
  if (!rest.startsWith('/')) rest = '/' + rest
  if (rest === '') rest = '/'
  // Přelokalizuj cestu do cílového jazyka (/en/tools/x → /de/werkzeuge/y).
  rest = relocalizePath(rest, fromLang, code)
  const target = code === 'cs' ? rest : '/' + code + (rest === '/' ? '' : rest)
  return target + window.location.search + window.location.hash
}
